export { default } from './part-feedback';
